import { render, staticRenderFns } from "./StorageSelectSectionContainer.vue?vue&type=template&id=28d8b1d6&lang=html&"
import script from "./StorageSelectSectionContainer.vue?vue&type=script&lang=ts&"
export * from "./StorageSelectSectionContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports